import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    deleteDoc,
    query,
    setDoc,
    where,
    orderBy,
    limit, writeBatch
} from "firebase/firestore";
import Promise from "bluebird";
import _ from "lodash";
import {fireStoreDB} from "../../firebase/client-app";
import {PRODUCT_DETAIL_KEY} from "../constants/pod.constant";

export {
    addProducts,
    updateProducts,
    updateSingleProduct,
    batchUpdateProducts,
    batchSaveProducts,
    deleteSingleProduct,
    getSingleProduct,
    searchProducts,
    getAllPODProducts,
    prepareProductsList
}

const collectionName = 'products';
const collectionReference = collection(fireStoreDB, collectionName);

const addProducts = (products) => {
    return Promise.map(products, async product => {
        console.log('.');
        await addSingleProduct(product);
    });
}

const updateProducts = (products) => {
    return Promise.map(products, async product => {
        console.log('.');
        await updateSingleProduct(product);
    });
}

const batchSaveProducts = async (products) => {
    let batch = writeBatch(fireStoreDB);
    const promises = [];
    const productsBatchList = _.chunk(products, 100);

    _.forEach(productsBatchList, (products) => {
        _.forEach(products, (product: any) => {
            if (product.id) {
                const docRef = doc(collectionReference, product.id);
                batch.update(docRef, product, {merge: true});
            } else {
                const docRef = doc(collectionReference);
                batch.set(docRef, product);
            }
        });

        promises.push(batch.commit());
        batch = writeBatch(fireStoreDB);
    });

    await Promise.all(promises);
    return;
};

const batchUpdateProducts = async (products) => {
    let batch = writeBatch(fireStoreDB);
    const promises = [];
    const productsBatchList = _.chunk(products, 100);

    _.forEach(productsBatchList, (products) => {
        _.forEach(products, (product: any) => {
            const docRef = doc(collectionReference, product.id);
            batch.update(docRef, product, {merge: true});
        });

        promises.push(batch.commit());
        batch = writeBatch(fireStoreDB);
    });

    await Promise.all(promises);
    return;
};

const addSingleProduct = (product) => {
    return addDoc(collectionReference, product);
}

const updateSingleProduct = (product) => {
    const documentReference = doc(fireStoreDB, collectionName, product.id);
    return setDoc(documentReference, product);
}

const deleteSingleProduct = (product) => {
    const documentReference = doc(fireStoreDB, collectionName, product.id);
    return deleteDoc(documentReference);
}

const getSingleProduct = (productId) => {
    const documentReference = doc(fireStoreDB, collectionName, productId);
    return getDoc(documentReference);
}

const searchProducts = async (searchCriteriaList) => {
    let searchQuery = query(collectionReference);

    _.forEach(searchCriteriaList, searchCriteria => {
        searchQuery = query(searchQuery,
            where(searchCriteria.field, searchCriteria.condition, searchCriteria.value));
    });

    searchQuery = query(searchQuery,
        limit(20));

    const productResult = await getDocs(searchQuery);
    return prepareProductsList(productResult);
}

const getAllPODProducts = async (podId) => {
    let searchQuery = query(collectionReference,
        where("podId", "==", podId));

    const productResult = await getDocs(searchQuery);
    return prepareProductsList(productResult);
}

const prepareProductsList = (productResult) => {
    const productsList = [];

    _.forEach(productResult.docs, productDoc => {
        productsList.push({
            ...productDoc.data(),
            id: productDoc.id
        });
    });

    return productsList;
}
